import SkeletonElement from "./skeletonElement";

export function LineSkeleton(lineCount) {
  var __html = [];
  for (var i = 0; i < lineCount; i++) {
    if (i % 2 === 0)
      __html.push(<SkeletonElement type="genericLineStyles sm" />);
    else __html.push(<SkeletonElement type="genericLineStyles md" />);
  }
  return __html;
}

export function LineSkeletonLg(props) {
  const classes = props?.classes ?? "";
  return <SkeletonElement type={`genericLineStyles lg ${classes}`} />;
}

export function ButtonSkeleton(props) {
  return <SkeletonElement type={`genericLineStyles ${props.type}`} />;
}

export function ImageSkeleton(props) {
  return <SkeletonElement type={`image img-fluid ${props.classes}`} />;
}
